import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../../../toolkit/uicomponentcss';
import { Colors } from '../../../../../utils/resources/colors';
import { Fonts } from '../../../../../utils/resources/fonts';

export interface TimeSettingsCSSStyle extends UIComponentCSSStyle
{
    getCloseButtonDivCSSStyle():object;
    getTimeHeaderCSSStyle(): object;
    getTimeValueCSSStyle(): object;
    getRepeatLabelCSSStyle():object;
    getRepeatDivCSSStyle():object;
}

export class TimeSettingsCSSStyleImpl extends UIComponentCSSStyleImpl implements TimeSettingsCSSStyle
{
    getTimeHeaderCSSStyle(): object {
        return {
            fontSize: this.getResources().getFont(Fonts.h7),
            color: "#999999",
            height: "15px",
            fontWeight: 300,
            fontFamily: this.getResources().getFontFamily(),
            letterSpacing: 0,
            lineHeight: "15px",
            outline: "none"
        };
    }

    getTimeValueCSSStyle(): object {
        return {
            fontSize: this.getResources().getFont(Fonts.h7),
            color: "#221E20",
            height: "15px",
            fontWeight: 500,
            fontFamily: this.getResources().getFontFamily(),
            letterSpacing: 0,
            lineHeight: "15px",
            outline: "none"
        };
    }

    getWrapperCSSStyle(): object
    {
        return {
            width:'100%',
            paddingBottom: "10px",
            paddingTop:"20px",
            paddingLeft: "0px",
            paddingRight: "0px",
         
            // backgroundColor:"#DcD",
        };
    }

    getInnerWrapperCSSStyle(): object 
    {
        return {
            backgroundColor: this.getResources().getColor(Colors.color_5),
            marginLeft: "170px",
            marginRight: "170px",
            marginTop: "72px",
            marginBottom: "72px",
        };
    }

    getCloseButtonDivCSSStyle():object
    {
        return{
            float:"right", marginTop:'5px', marginRight:"5px",backgroundColor:'#F4F4F4',display:'flex'
        };
    }
   
    getRepeatLabelCSSStyle():object
    {
        return{
            width:'100%',
            marginTop:'30px', 
            height:'20px',
            marginBottom:'20px',
            fontFamily: this.getResources().getFontFamily(),
            fontSize: this.getResources().getFont(Fonts.h7),            
            lineHeight:'20px',
            color: "#221E20",
        };
    }

    getRepeatDivCSSStyle2():object
    {
     return{
        width:'50%', 
        height:'40px',
        margin:'0p',
        fontWeight:'500',
        fontFamily: this.getResources().getFontFamily(),
        lineHeight:'20px',
        color:this.getResources().getColor(Colors.color_6), 
        fontSize:this.getResources().getFont(Fonts.h7),
        display:'flex'
     }; 
    }
    getRepeatDivCSSStyle():object
    {
        return{

        width:'100%', 
        height:'40px',
        margin:'0p',
        fontWeight:'500',
        fontFamily: this.getResources().getFontFamily(),
        lineHeight:'20px',
        color:this.getResources().getColor(Colors.color_6), 
        fontSize:this.getResources().getFont(Fonts.h7),
        display:'flex'
        };
    }
   
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/tunesettings/timesettings/timesettingscss.tsx